import React from 'react'
import { injectState } from 'freactal'
import app from '../../../../feathers'
import { hasElement, alphabet } from '../../../../lib'
import { Checkbox } from 'react-mdl'
import { toRoman } from 'roman-numerals'

const units = app.service('units')
class SummativePracticalContent extends React.Component {
  state = {
    summativePracticalMapping: [],
  }

  componentDidMount() {
    this.initialMapping()
  }

  componentWillReceiveProps() {
    this.initialMapping()
  }

  initialMapping = () =>
    this.setState({
      summativePracticalMapping: this.props.state.unit
        .summativePracticalAssessments,
    })

  handleChangeSummativePracMapping = async (e, taskIndex) => {
    const { _id } = this.props.state.unit
    const { unitElement } = this.props
    const isChecked = e.target.checked
    const op = isChecked ? '$push' : '$pull'
    const path = taskIndex.reduce((path, number, i) => {
      let newPath
      switch (i) {
        case 0:
          newPath = `${path}.${number}`
          break
        case 1:
          newPath = `${path}.tasks.${number}`
          break
        case 2:
          newPath = `${path}.subtasks.${number}`
          break
        default:
          newPath = `${path}`
      }
      return newPath
    }, 'summativePracticalAssessments')
    await units.patch(_id, {
      [op]: {
        [`${path}.mapping`]: unitElement,
      },
    })
  }

  render() {
    const { summativePracticalMapping } = this.state
    const { unitElement } = this.props

    return (
      <tbody>
        {summativePracticalMapping.map(({ mapping, tasks, name }, i) => [
          <tr key={`summativePractical-${i}`}>
            <td>
              <Checkbox
                onChange={e => this.handleChangeSummativePracMapping(e, [i])}
                checked={hasElement(unitElement, mapping)}
              />
            </td>
            <td>
              <b>
                Task {i + 1} {name}
              </b>
            </td>
          </tr>,
          ...tasks.map(({ mapping: subMapping, task, subtasks }, j) => [
            <tr key={`summativePractical-${i}${j}`}>
              <td>
                <Checkbox
                  onChange={e =>
                    this.handleChangeSummativePracMapping(e, [i, j])}
                  checked={hasElement(unitElement, subMapping)}
                />
              </td>
              <td>
                <u>
                  Task {i + 1}
                  {alphabet[j]}
                </u>
              </td>
            </tr>,
            ...subtasks.map(
              (
                {
                  mapping: subSubMapping,
                  task: subSubTask,
                  subtasks: subSubSubTasks,
                },
                k,
              ) => [
                <tr key={`summativePractical-${i}${j}${k}`}>
                  <td>
                    <Checkbox
                      onChange={e =>
                        this.handleChangeSummativePracMapping(e, [i, j, k])}
                      checked={hasElement(unitElement, subSubMapping)}
                    />
                  </td>
                  <td>
                    <i>
                      Task {i + 1}
                      {alphabet[j]}
                      ({toRoman(k + 1).toLowerCase()})
                    </i>
                  </td>
                </tr>,
              ],
            ),
          ]),
        ])}
      </tbody>
    )
  }
}

export default injectState(SummativePracticalContent)



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/MappingModal/SummativePracticalContent.js